import React from "react";

export type UploadIconProps = {
  cx?: string;
};

export const UploadIcon: React.FC<UploadIconProps> = ({ cx = "" }) => {
  return (
    <svg
      className={cx}
      width="14"
      height="17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7 2v.5h2.8v14H.5V.5h10.2V2zm1-.5V.972l.74.528h-.74z"
        stroke="#E9E9E9"
      />
      <path d="m5 8 2-2 2 2m-2 4V7" stroke="#fff" strokeLinecap="round" />
    </svg>
  );
};
